<template>
  <b-container fluid>
    <b-jumbotron>
      <div class="home">
        <span
          v-for="language in availableLanguages"
          :key="language"
          @click="switchLanguage(language)"
        >
          <country-flag size="big" v-bind:country="language"></country-flag>
        </span>
      </div>
      {{ $t("T6") }}
      <br><br>
      {{ $t("T7") }}
    </b-jumbotron>
    <b-container class="mt-2 mb-4">
      <b-img style="height: 200px" :src="require('../assets/logo.jpg')" />
    </b-container>
    <a href="#requestForm" class="btn btn-primary"
      >{{ $t("T3") }}
      <font-awesome-icon :icon="['fas', 'arrow-down']"></font-awesome-icon>
    </a>
    <b-jumbotron class="mt-5">
      <b-container class="mt-2">
        <h2 class="mt-4">{{ $t("E1") }}</h2>
        <p class="mt-2">{{ $t("E2") }}</p>
        <h3 class="mt-4">{{ $t("E3") }}</h3>
        <p>{{ $t("E4") }}</p>
        <p>{{ $t("E5") }}</p>
        <p>{{ $t("E6") }}</p>
      </b-container>
    </b-jumbotron>
    <request-form />
    <b-jumbotron>
      <p class="mt-2">
        <a
          href="https://kreisklinik-roth.de/geburtshilfe-in-der-kreisklinik-roth"
          target="_blank"
        >
          Die familiäre Geburtsklinik im Grünen – Kreisklinik Roth
        </a>
      </p>
      <p class="mt-2">
        <a
          href="https://kreisklinik-roth.de/kursprogramm?kathaupt=1&katid=2&katname=Junge%20Familie%20und%20Geburt&katvaterid=0&cHash=a142f6ef82b94df0310412dd2db3c58e"
          target="_blank"
        >
          Der Eltern Info-Abend und weitere Kursangebote
        </a>
      </p>
      {{ $t("T8") }}
    </b-jumbotron>
    <div class="bg-light border p-2">
      <a href="#" class="text-secondary" @click.prevent="showImpressumModal">
        Impressum
      </a>
    </div>
    <impressum-modal ref="modal-impressum" />
  </b-container>
</template>

<script>
import RequestForm from "../components/RequestForm.vue";
import CountryFlag from "vue-country-flag";
import ImpressumModal from "../components/modals/ImpressumModal";

export default {
  name: "home",
  components: {
    ImpressumModal,
    RequestForm,
    CountryFlag
  },
  data: function() {
    return {
      availableLanguages: ["de", "gb", "pt", "fr", "es", "cn", "tr", "sa", "th"]
    };
  },
  methods: {
    switchLanguage: function(language) {
      this.$i18n.locale = language;
    },
    showImpressumModal() {
      this.$refs["modal-impressum"].show();
    }
  }
};
</script>
<style></style>
